import { render, staticRenderFns } from "./ItemShopnews.vue?vue&type=template&id=f39894e8"
import script from "./ItemShopnews.vue?vue&type=script&lang=js"
export * from "./ItemShopnews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports